import React, { useCallback, useEffect, useState, useRef } from "react";
import { format } from "date-fns";
// Pagination component
import Grid from "@mui/material/Grid";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardActionArea,
  CardMedia,
  Checkbox,
  Fade,
  FormControlLabel,
  Grow,
  IconButton,
  List,
  ListItem,
  Paper,
  Popper,
  Tab,
  Typography,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import AutoCompleteComponent from "../../components/autoCompleteComponent/Autocomplete";
import DatePicker from "../../components/dateRangePickerComponent/DateRangePicker";
import MuiButton from "../../components/muiButton/MuiButton";
import PostPlusButton from "../../components/postPlusButton/PostPlusButton";
import LoadingIndicator from "../../components/loading-indicator/LoadingIndicator";
import NoDataFound from "../../components/nodatafound/NoDataFound";
import { theme } from "../App";
import InstagramIcon from "@mui/icons-material/Instagram";
import InfluencersCampaignsAction from "../../stores/influencersCampaigns/InfluencersCampaignsAction";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import PaginationUI from "../../components/pagination/Pagination";
// import AddCampaign from "./AddCampaign";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AddInfluencerPermission from "./AddInfluencerPermission";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ClearIcon from "@mui/icons-material/Clear";
import { returnLogo } from "../../components/ticketPartials";
import StatusAction from "../../stores/status/StatusAction";
import TagAction from "../../stores/tag/TagAction";
import CustomTicketFieldsAction from "../../stores/customticketfields/CustomTicketFieldsAction";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import MuiSnackbarAlert from "../../components/muiSnackBarAlert/MuiSnackbarAlert";
import MuiTextField from "../../components/muiTextField/MuiTextField";
import InfluencerUserAction from "../../stores/influencerUser/InfluencerUserAction";
import InfluencerLogo from "../../components/logo/influencerLogo.png";

// mapstateto props function
const mapStateToProps = (state, ownProps) => ({
  isRequesting: selectRequesting(state, [
    InfluencersCampaignsAction.REQUEST_INFLUENCERS_CAMPAIGNS_FILTER,
    InfluencersCampaignsAction.REQUEST_INFLUENCERS_CAMPAIGNS,
    // StatusAction.REQUEST_STATUS_FILTER,
    InfluencerUserAction.REQUEST_INFLUENCER_USER,
    TagAction.REQUEST_TAG_FILTER,
    CustomTicketFieldsAction.REQUEST_CUSTOMTICKETFIELDS,
  ]),
  influencersCampaign: state.influencersCampaign.influencersCampaign.hits || [],
  influencerUser: state.influencerUser.influencerUser || [],
  // statusFilter: state.statusFilter.statusFilter || [],
  tagfilter: state.tagfilter.tagfilter || [],
  customticketfields: state.customticketfields.customticketfields || {},
  pagination: state.influencersCampaign.influencersCampaign || {},
  influencersCampaignFilter:
    state.influencersCampaignFilter.influencersCampaignFilter.hits || [],
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function InfluencersCampaigns(props) {
  let { state } = useLocation();
  const localFilters = JSON.parse(localStorage.getItem("myCampaignClient"));

  // useState Functions
  const [showDropDowns, setShowDropDowns] = useState([
    "Campaign",
    "Status",
    "Category",
    "Platform",
    "Date",
    "Locations",
  ]);

  const [selected, setSelected] = useState([
    "Campaign",
    "Status",
    "Category",
    "Platform",
    "Date",
  ]);

  const boxRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [value, setValue] = React.useState("1");
  const [page_limit] = useState(15);
  const [filterLoader, setFilterLoader] = useState(false);
  const [clearLoader, setClearLoader] = useState(false);
  const [FilterClicked, setFilterClicked] = useState(false);
  const [editRowsModel, setEditRowsModel] = useState({});
  const [edit, setEdit] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  const [openRender, setopenRender] = useState(false);
  const [noFilterAlert, setNoFilterAlert] = useState(false);
  const [locations, setLocations] = useState([]);

  const [date, setDate] = useState(() => {
    return localFilters ? localFilters.date : [null, null];
  });

  const [platformValue, setPlatformValue] = useState(() => {
    return localFilters ? localFilters.platformValue : [];
  });

  const [campaignName, setCampaignName] = useState(() => {
    // if (state && state.reverted === true) {
    //   return JSON.parse(localStorage.getItem("myCampaignClient")).campaignName;
    return localFilters ? localFilters.campaignName : "";
    // } else {
    //   return null;
    // }
  });

  const [pageNumber, setPageNumber] = useState(() => {
    return localFilters ? localFilters.pageNumber : 1;
  });

  // const [statusName, setStatusName] = useState(() => {
  //   if (state && state.reverted === true) {
  //     return JSON.parse(localStorage.getItem("myCampaignClient")).statusName;
  //   } else {
  //     return null;
  //   }
  // });

  // const [category, setCategory] = useState(() => {
  //   if (state && state.reverted === true) {
  //     return JSON.parse(localStorage.getItem("myCampaignClient")).category;
  //   } else {
  //     return null;
  //   }
  // });

  const openCloseModal = useCallback((open) => {
    setOpen(open);
  }, []);

  // importing useStyes hook
  const { isRequesting } = props;

  //tab handle change
  const TabhandleChange = (event, newValue) => {
    setValue(newValue);
  };

  // ************************************************* Dispatch functions

  function fetchInfluenceUser() {
    let params = {
      page_limit: "none",
      order_by: '[["created_on", "desc"]]',
    };
    props.dispatch(InfluencerUserAction.requestInfluencerUser(params));
  }

  function fetchInfluencerscampaigns(params) {
    props.dispatch(
      InfluencersCampaignsAction.requestInfluencerCampaigns(params)
    );
  }

  function fetchInfluencerscampaignsFilter() {
    let params = {
      page_limit: "none",
      order_by: '[["modified_on", "desc"]]',
    };
    props.dispatch(InfluencersCampaignsAction.requestInfluencersFilter(params));
  }

  // function fetchcategory(params) {
  //   props.dispatch(CategoryAction.requestCategory(params));
  // }

  function fetchStatusFilter() {
    const param = {
      page_limit: "none",
      order_by: `[["order_number","asc"]]`,
    };
    props.dispatch(StatusAction.requestStatusFilter(param));
  }

  function fetchTagFilter() {
    const param = {
      page_limit: "none",
      order_by: `[["order_number","asc"]]`,
    };
    props.dispatch(TagAction.requestTagFilter(param));
  }

  // function fetchPlatformFilter() {
  //   let param = {
  //     //   level: "organization",
  //     page_limit: "none",
  //     order_by: `[["platform_name.keyword","asc"]]`,
  //   };
  //   props.dispatch(PlatformAction.requestPlatform(param));
  // }

  useEffect(() => {
    if (!isRequesting) {
      setFilterLoader(false);
      setClearLoader(false);
    }
  }, [isRequesting]);

  function CampaignNameFilter(campaignName) {
    return `["campaign_name.keyword","must","","wildcard","*${campaignName}*"]`;
  }

  // function statusFilter(statusName) {
  //   return `["status.keyword","must","","match","${statusName.status_id}"]`;
  // }

  function platformFilter(platform) {
    return `["target_platforms","must","nested","",["platform_name.keyword","must","","terms",${JSON.stringify(
      platform
    )}]]`;
  }

  function locationsFilter(locations) {
    return `["target_locations.keyword","must","","terms",${JSON.stringify(
      locations
    )}]`;
  }

  // function categoryFilter(category) {
  //   return `["category.category_name.keyword","must","","match","${category}"]`;
  // }

  function CustomDateFilter() {
    if (date[1].$d || date[0].$d)
      return `["created_on","must","lte","range","${format(
        date[1].$d,
        "yyyy-MM-dd"
      )}"],["created_on","must","gte","range","${format(
        date[0].$d,
        "yyyy-MM-dd"
      )}"]`;
    else {
      return `["created_on","must","lte","range","${format(
        new Date(date[1]),
        "yyyy-MM-dd"
      )}"],["created_on","must","gte","range","${format(
        new Date(date[0]),
        "yyyy-MM-dd"
      )}"]`;
    }
  }

  const [token, setToken] = useState(null);

  //   UseEffect function
  useEffect(() => {
    if (localFilters) {
      applyFilter();
      return;
    }
    let params = {};
    let filterArray = [];

    if (campaignName) {
      filterArray.push(CampaignNameFilter(campaignName));
    }
    // if (statusName !== null) {
    //   filterArray.push(statusFilter(statusName));
    // }
    if (platformValue && platformValue.length !== 0) {
      filterArray.push(platformFilter(platformValue));
    }
    if (locations && locations.length !== 0) {
      filterArray.push(locationsFilter(locations));
    }
    // if (category !== null) {
    //   filterArray.push(categoryFilter(category));
    // }
    if (date[0] !== null && date[1] !== null) {
      filterArray.push(CustomDateFilter());
    }

    if (
      campaignName ||
      // statusName !== null ||
      // category !== null ||
      (platformValue && platformValue.length !== 0) ||
      (date[0] !== null && date[1] !== null)
    ) {
      params = {
        filters: `[${filterArray}]`,
        page_number: state
          ? state.reverted === true
            ? state.pageNumber
            : 0
          : 0,
        page_limit: `${page_limit}`,
        order_by: '[["modified_on", "desc"]]',
      };
    } else {
      params = {
        page_number: state
          ? state.reverted === true
            ? state.pageNumber
            : 0
          : 0,
        page_limit: `${page_limit}`,
        order_by: '[["modified_on", "desc"]]',
      };
    }

    let param = {
      page_limit: "none",
    };
    fetchInfluencerscampaigns(params);
    fetchInfluencerscampaignsFilter(param);
    fetchInfluenceUser();
    // fetchcategory(param);
    // fetchPlatformFilter();
    // fetchStatusFilter();
    // fetchTagFilter();
  }, []);
  // applyFilter Function
  const applyFilter = () => {
    let params = {};
    let filterArray = [];

    if (campaignName) {
      filterArray.push(CampaignNameFilter(campaignName));
    }

    // if (statusName !== null) {
    //   filterArray.push(statusFilter(statusName));
    // }

    if (platformValue && platformValue.length !== 0) {
      filterArray.push(platformFilter(platformValue));
    }

    if (locations && locations.length !== 0) {
      filterArray.push(locationsFilter(locations));
    }

    // if (category !== null) {
    //   filterArray.push(categoryFilter(category));
    // }

    if (date[0] !== null && date[1] !== null) {
      filterArray.push(CustomDateFilter());
    }
    if (
      campaignName ||
      // statusName !== null ||
      // category !== null ||
      (date[0] !== null && date[1] !== null) ||
      (platformValue && platformValue.length !== 0) ||
      (locations && locations.length !== 0)
    ) {
      params = {
        filters: `[${filterArray}]`,
        page_number: 0,
        page_limit: `${page_limit}`,
        order_by: '[["modified_on", "desc"]]',
      };
      setFilterLoader(true);
      setFilterClicked(true);
      fetchInfluencerscampaigns(params);
      localStorage.setItem(
        "myCampaignClient",
        JSON.stringify({
          campaignName: campaignName,
          platformValue: platformValue,
          pageNumber,
          date: date,
        })
      );
    } else {
      setNoFilterAlert(true);
    }
  };

  //  campaignNameHandleChange
  const campaignNameHandleChange = (event) => {
    setCampaignName(event.target.value);
  };

  //  statusNameHandleChange
  // const statusNameHanldeChange = (event, value) => {
  //   if (value != null) {
  //     setStatusName(value);
  //   } else {
  //     setStatusName(null);
  //   }
  // };

  const editMode = useCallback((edit) => {
    setEdit(false);
  }, []);

  //  category handle change
  // const categoryHandleChange = (event, value) => {
  //   if (value != null) {
  //     setCategory(value);
  //   } else {
  //     setCategory(null);
  //   }
  // };

  // ************************************* Filter List

  let campaignNameList = [];

  if (props.influencersCampaignFilter.hits) {
    props.influencersCampaignFilter.hits.map((item) => {
      return campaignNameList.push(item._source.campaign_name);
    });
  }

  campaignNameList.sort((a, b) => a.localeCompare(b));
  campaignNameList = [...new Set(campaignNameList)];

  let locationsList = [];

  if (props.influencersCampaignFilter.hits?.length) {
    props.influencersCampaignFilter.hits.map((item) => {
      item._source.target_locations?.map((item) => {
        return locationsList.push(item);
      });
    });
  }

  locationsList = [...new Set(locationsList)];

  // pagination
  const handleChangePagination = (event, value) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    let params = {};

    let filterArray = [];

    if (campaignName) {
      filterArray.push(CampaignNameFilter(campaignName));
    }

    // if (statusName !== null) {
    //   filterArray.push(statusFilter(statusName));
    // }

    if (platformValue && platformValue.length !== 0) {
      filterArray.push(platformFilter(platformValue));
    }

    if (locations && locations.length !== 0) {
      filterArray.push(locationsFilter(locations));
    }

    // if (category !== null) {
    //   filterArray.push(categoryFilter(category));
    // }

    if (date[0] !== null && date[1] !== null) {
      filterArray.push(CustomDateFilter());
    }

    if (FilterClicked) {
      if (
        campaignName ||
        // statusName !== null ||
        // category !== null ||
        platformValue !== null ||
        (locations && locations.length !== 0)
      ) {
        params = {
          filters: `[${filterArray}]`,
          page_number: `${value}` - 1,
          page_limit: `${page_limit}`,
          order_by: '[["modified_on", "desc"]]',
        };
      }
    } else {
      params = {
        page_number: `${value}` - 1,
        page_limit: `${page_limit}`,
        order_by: '[["modified_on", "desc"]]',
      };
    }
    fetchInfluencerscampaigns(params);

    setPageNumber(value);
    let filters = localFilters;
    if (filters) {
      filters.pageNumber = value;
      localStorage.setItem("myActivityFilters", JSON.stringify(filters));
    }
  };

  const location = useLocation();

  const dateValueHandleChange = (e) => {
    setDate(e);
  };
  const [expanded, setExpanded] = React.useState(false);

  const handleChangeExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [expanded_2, setExpanded_2] = React.useState(false);

  const handleChangeExpand_2 = (panel) => (event, isExpanded) => {
    setExpanded_2(isExpanded ? panel : false);
  };

  const navigate = useNavigate();

  const navigateToMyPosts = (item) => {
    navigate(`/InfluencersAllActivity`, {
      state: {
        campaign_id: item._id,
        campaign_name: item._source.campaign_name,
        pageNumber: props.pagination.current_page_no,
        token: token,
        from: location.pathname,
        // pageLimit: page_limit,
        // platform: e.row.platform,
        // allTickets_list: props.tickets.hits
        //     ? props.tickets.hits.hits
        //     : null,
      },
    });
  };

  let platform_list_for_post = [];
  let platform_name_list = [];

  // if (platform_list_for_post.length > 0) {
  //   platform_list_for_post.map((item) => {
  //     platform_name_list.push(item.platform_name);
  //   });
  // }
  if (props.influencerUser.hits?.hits[0]?._source) {
    props.influencerUser.hits?.hits[0]?._source.social_media_platforms.map(
      (item) => {
        platform_list_for_post.push({
          platform_id: item.platform_id,
          platform_name: item.platform_name,
        });
      }
    );
  }
  if (platform_list_for_post.length > 0) {
    platform_list_for_post.map((item) => {
      platform_name_list.push(item.platform_name);
    });
  }

  // let statuslist_for_post = [];
  // if (props.statusFilter.hits) {
  //   props.statusFilter.hits.hits.forEach((value) => {
  //     statuslist_for_post.push({
  //       status_id: value._id,
  //       status_name: value._source.status_name,
  //     });
  //   });
  // }

  // let statusList = [];
  // if (statuslist_for_post.length > 0) {
  //   statuslist_for_post.map((item) => {
  //     statusList.push(item.status_name);
  //   });
  // }

  // const filterStatusList = [...new Set(statusList)];

  let statuslist_for_post = [
    {
      status_id: "LHemp40B6w3e_cmirVrO",
      status_name: "Open",
    },
    {
      status_id: "2",
      status_name: "Close",
    },
    {
      status_id: "3",
      status_name: "Hold",
    },
  ];

  const returnStatusName = (statusId) => {
    let filtered_status =
      statuslist_for_post.length > 0 &&
      statuslist_for_post.filter((val) => {
        return val.status_id === statusId;
      });

    return filtered_status.length > 0 ? filtered_status[0].status_name : ``;
  };

  // let categoryList = [];

  // if (props.category.hits) {
  //   props.category.hits.length > 0 &&
  //     props.category.hits.map((item) => {
  //       categoryList.push(item._source.category_name);
  //     });
  // }

  const platform_HandleChange = (event, value) => {
    if (value != null) {
      setPlatformValue(value);
    } else {
      setPlatformValue([]);
    }
  };

  const locations_handlechange = (event, value) => {
    if (value != null) {
      setLocations(value);
    } else {
      setLocations([]);
    }
  };

  const deletePlatformChip = (item) => {
    const updatedChip = platformValue.filter((obj) => obj !== item);
    if (updatedChip.length == 0) {
      ClearState();
    } else setPlatformValue(updatedChip);
  };

  let taglist_for_post = [];
  if (props.tagfilter.hits) {
    props.tagfilter.hits.hits.forEach((value) => {
      taglist_for_post.push({
        tag_id: value._id,
        tag_name: value._source.tag_name,
      });
    });
  }

  // const filterCategoryList = [...new Set(categoryList)];

  const [popperAnchor, setPopperAnchor] = React.useState(null);

  const handleClick = (event) => {
    setPopperAnchor(popperAnchor ? null : event.currentTarget);
  };

  const openPopper = Boolean(popperAnchor);

  const handleChangeDropDowns = (event) => {
    const value = event.target.value;

    if (selected.indexOf(value) !== -1) {
      // if value already present
      const newSelected = selected.filter((s) => s !== value);
      setSelected(newSelected);
    } else {
      // if value not present
      setSelected([...selected, value]);
    }
  };

  const ClearState = () => {
    setFilterClicked(false);
    if (
      campaignName ||
      platformValue ||
      // statusName !== null ||
      // category !== null ||
      (date[0] !== null && date[1] !== null) ||
      campaignName ||
      (locations && locations.length !== 0)
    ) {
      setCampaignName("");
      // setStatusName(null);
      setPlatformValue([]);
      // setCategory(null);
      setDate([null, null]);
      setClearLoader(true);
      setLocations([]);
    } else {
      setNoFilterAlert(true);
      setClearLoader(false);
      return;
    }

    let params = {
      page_limit: `${page_limit}`,
      order_by: '[["modified_on", "desc"]]',
    };

    localStorage.removeItem("myCampaignClient");
    navigate("/InfluencersCampaigns", (state = { reverted: false }));

    fetchInfluenceUser();
    FilterClicked && fetchInfluencerscampaigns(params);
    FilterClicked && fetchInfluencerscampaignsFilter();
  };

  return (
    <React.Fragment>
      {/* <PostUrl open={open} onSubmit={() => { }} onClose={() => setOpen(false)} /> */}
      {/* *******************************************************Filters */}
      <Box ref={boxRef}>
        <Grid
          container
          sx={{
            position: "sticky",
            top: `${boxRef?.current?.offsetTop}px`,
            zIndex: 1,
            backgroundColor: theme.palette.background.default,
            // paddingX: "1.5%",
            paddingTop: 0,
            borderRadius: theme.borderRadius,
          }}
        >
          <Typography
            pl={1}
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              marginY: "10px",
              fontSize: "21px",
            }}
          >
            Campaigns List
          </Typography>

          {/* Filter List */}
          <Box
            sx={{
              // width: "calc(100% - 110px)",
              width: "100%",
              paddingY: "1.5%",
              paddingX: "0.5%",
              marginX: "10px",
              // marginRight: "100px",
              // backgroundColor: theme.palette.background.default,
              backgroundColor: "white",
              border: "solid 0.5px #d3e2e6",
              borderRadius: theme.borderRadius,
            }}
          >
            <Grid
              container
              pl={2.5}
              sx={{
                height: "auto",
                borderRadius: theme.borderRadius,
              }}
            >
              <Grid
                container
                lg={12}
                md={12}
                sm={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid item container xl={9} lg={9} md={12} sm={12} gap={2}>
                  {selected && selected.includes("Campaign") && (
                    <Grid item xl={2} lg={5} md={5} sm={6}>
                      <MuiTextField
                        value={campaignName}
                        variant="outlined"
                        placeholder={"Search Campaign"}
                        sx={{ width: "100%" }}
                        size="small"
                        onChange={campaignNameHandleChange}
                      />
                    </Grid>
                  )}
                  {selected && selected.includes("Platform") && (
                    <Grid
                      item
                      xl={platformValue?.length > 0 ? 3 : 2.6}
                      lg={5}
                      md={5}
                      sm={6}
                      mb={1}
                      style={{ position: "relative" }}
                      alignItems="flex-start"
                      justifyContent="center"
                    >
                      <Grid item xl={12}>
                        <AutoCompleteComponent
                          multiple
                          value={platformValue}
                          list={platform_name_list}
                          disableClearable
                          disablePortal
                          disableCloseOnSelect={true}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option}
                            </li>
                          )}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                label={chipTextDelimiter(option)}
                                variant="outlined"
                                size="small"
                                className="mx-1"
                                onDelete={() => {
                                  deletePlatformChip(option);
                                }}
                              />
                            ))
                          }
                          limitTags={1}
                          textFieldProps={{
                            placeholder: platformValue.length
                              ? null
                              : "Platforms",
                            zIndex: 999,
                          }}
                          handleChange={platform_HandleChange}
                          size="small"
                          width="100%"
                        />
                      </Grid>
                    </Grid>
                  )}

                  {selected && selected.includes("Locations") && (
                    <Grid
                      item
                      xl={2.7}
                      lg={5}
                      md={5}
                      sm={6}
                      mb={1}
                      style={{ position: "relative" }}
                      alignItems="flex-start"
                      justifyContent="center"
                    >
                      <Grid
                        item
                        xl={12}
                        style={{
                          position: "absolute",
                          width: "95%",
                          zIndex: 999,
                        }}
                      >
                        <AutoCompleteComponent
                          // ***************************************************Customer name filter
                          multiple
                          value={locations}
                          list={locationsList}
                          disableClearable
                          textFieldProps={{
                            placeholder: locations.length ? null : "Locations",
                          }}
                          disableCloseOnSelect={true}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option}
                            </li>
                          )}
                          limitTags={1}
                          handleChange={locations_handlechange}
                          size="small"
                          width="100%"
                        />
                      </Grid>
                    </Grid>
                  )}

                  {selected && selected.includes("Date") && (
                    <Grid item lg={4} md={4} sm={6}>
                      <DatePicker
                        value={date ? date : [null, null]}
                        onChange={dateValueHandleChange}
                      />
                    </Grid>
                  )}
                </Grid>

                {/* <AddInfluencerPermission
              open={openUser}
              onClose={() => setOpenUser(false)}
              projectProps={editRowsModel}
              render={openRender}
              onCloseRender={() => setopenRender(false)}
            /> */}
                <Grid
                  item
                  xl={3}
                  lg={3}
                  md={6}
                  sm={7}
                  mt={{ md: 1, lg: 0, sm: 1, xl: 0 }}
                  pr={2.5}
                >
                  <Grid
                    item
                    sm={12}
                    container
                    spacing={2}
                    justifyContent="flex-end"
                  >
                    <Grid item xl={3.5} lg={6} md={3} sm={4}>
                      <MuiButton
                        loading={filterLoader && isRequesting}
                        name={"Apply"}
                        width="100%"
                        onClick={applyFilter}
                      />
                    </Grid>
                    <Grid item xl={3.5} lg={6} md={3} sm={4}>
                      <MuiButton
                        backgroundColor={theme.palette.secondary.main}
                        width="100%"
                        loading={clearLoader && isRequesting}
                        name={"Clear"}
                        onClick={ClearState}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Grid
          container
          sx={{
            backgroundColor: theme.palette.background.default,
            paddingX: "10px",
            paddingTop: 0,
            // borderRadius: theme.palette.buttonComponent.borderRadius.large,
            borderRadius: theme.borderRadius,
            marginY: 5,
          }}
          // className="bg-info"
        >
          {/* ****************************************************** Divider */}

          <Grid
            container
            sx={{
              backgroundColor: theme.palette.background.paper,
              borderRadius: theme.borderRadius,
            }}
          >
            {/* ******************************************************PLay Store List */}

            <Box
              sx={{
                width: "100%",
                backgroundColor: theme.palette.background.default,
                border: "solid 0.5px #d3e2e6",
                boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.16)",
                borderRadius: theme.borderRadius,
              }}
              // className="bg-primary"
            >
              <Grid
                container
                px={2.5}
                py={1}
                sx={{
                  height: "auto",
                }}
              >
                <Grid container lg={12} md={12} sm={12} spacing={2}>
                  <Grid item sx={{ fontSize: "16px", fontWeight: "bold" }}>
                    Campaigns
                  </Grid>
                </Grid>
              </Grid>

              <LoadingIndicator isActive={isRequesting}>
                {props.influencersCampaign.hits &&
                !isRequesting &&
                props.influencersCampaign.hits.length !== 0 ? (
                  props.influencersCampaign.hits.map((item, index) => (
                    <Box
                      sx={{
                        padding: 0,
                        margin: "1.2%",
                        marginTop: 0,
                        marginBottom: "0.5%",
                        borderRadius: theme.borderRadius,
                        cursor: "pointer",
                      }}
                      height={190}
                      onClick={() => {
                        navigateToMyPosts(item);
                      }}
                      // className="bg-warning"
                    >
                      <Box
                        style={{
                          backgroundColor: "#fff",
                          height: "100%",
                          padding: 2,
                          borderRadius: theme.borderRadius,
                          border: "solid 0.5px #d3e2e6",
                          boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.16)",
                        }}
                      >
                        <Grid
                          item
                          xl={12}
                          lg={12}
                          md={12}
                          sm={12}
                          container
                          textAlign={"center"}
                          justifyContent="center"
                          height="100%"
                        >
                          <Grid item xl={2}>
                            <Box
                              sx={{
                                position: "relative",
                                width: "100%",
                                height: "100%",
                              }}
                            >
                              <img
                                src={
                                  Object.values(
                                    item._source.thumbnail_urls
                                  ).every((value) => value === "")
                                    ? InfluencerLogo
                                    : item._source.thumbnail_urls &&
                                      item._source.thumbnail_urls.mobile
                                }
                                style={{
                                  position: "absolute",
                                  left: "0%",
                                  right: "0%",
                                  bottom: "0%",
                                  top: "0%",
                                  height: "0%",
                                  width: "0%",
                                  minWidth: "100%",
                                  maxWidth: "100%",
                                  minHeight: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                }}
                              ></img>
                            </Box>
                          </Grid>
                          <Grid item container xl={10} px={1}>
                            <Grid item lg={12} md={12} sm={12} container>
                              <Grid
                                item
                                container
                                xl={12}
                                lg={6}
                                md={12}
                                sm={12}
                                // className="bg-warning"
                                justifyContent="space-between"
                                alignItems={"center"}
                              >
                                <Grid xl={6} item textAlign="left">
                                  <span
                                    style={{
                                      marginRight: "20px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {item._source.campaign_name}{" "}
                                  </span>
                                  <span>
                                    {`${
                                      item._source.duration &&
                                      item._source.duration.from_date
                                    } - ${
                                      item._source.duration &&
                                      item._source.duration.to_date
                                    }`}
                                  </span>
                                </Grid>
                              </Grid>

                              {item._source.status && (
                                <Grid item xl={3} lg={3} md={12} sm={12}>
                                  <ListItem>
                                    <span>Campaign Status :</span>&nbsp;
                                    {returnStatusName(item._source.status)}
                                  </ListItem>
                                </Grid>
                              )}

                              <Grid item xl={3} lg={3} md={12} sm={12}>
                                <ListItem>
                                  <span>Project :</span>&nbsp;
                                  {item._source.project &&
                                    item._source.project.project_name}
                                </ListItem>
                              </Grid>
                              <Grid item xl={3} lg={3} md={12} sm={12}>
                                <ListItem>
                                  <span>Category :</span>&nbsp;
                                  {item._source.category &&
                                    item._source.category.category_name}
                                </ListItem>
                              </Grid>

                              {/* <Grid item xl={3} lg={3} md={12} sm={12}>
                              <ListItem>
                                <span>Tags :</span>&nbsp;
                                {item._source.tag && item._source.tag.tag_name}
                              </ListItem>
                            </Grid> */}

                              <Grid item xl={3} lg={3} md={12} sm={12}>
                                <ListItem>
                                  <span>Campaign Owner :</span>&nbsp;
                                  {item._source.campaign_owner}
                                </ListItem>
                              </Grid>

                              <Grid item xl={6} lg={6} md={12} sm={12}>
                                <ListItem
                                  sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                  }}
                                >
                                  <span>Platforms :</span>&nbsp;
                                  {item._source.target_platforms.map((item) => {
                                    return (
                                      <span
                                        style={{
                                          maxHeight: "15px",
                                          marginRight: "2px",
                                          marginLeft: "2px",
                                        }}
                                      >
                                        {returnLogo(item.platform_name)}
                                      </span>
                                    );
                                  })}
                                </ListItem>
                              </Grid>

                              {/* <Grid
                              item
                              // xl={3} lg={4} md={12} sm={12}
                            >
                              <ListItem>
                                <span>Locations :</span>&nbsp;
                                {item._source.target_locations &&
                                  item._source.target_locations.map((item) => (
                                    <span>{`${item}`} &nbsp; </span>
                                  ))}
                              </ListItem>
                            </Grid> */}
                            </Grid>
                            <Grid
                              item
                              container
                              lg={12}
                              md={12}
                              sm={12}
                              alignItems={"flex-start"}
                              justifyContent="flex-start"
                              sx={{ whiteSpace: "pre-wrap" }}
                            >
                              <Grid ml={2}>
                                {/* <ListItem> */}
                                <span>Campaign Description :</span>
                                &nbsp;
                                {""}
                                {/* </ListItem> */}
                              </Grid>

                              <Grid
                                xs={10}
                                className="scrollable"
                                sx={{
                                  height: 50,
                                  overflow: "auto",
                                  textAlign: "start",
                                  backgroundColor:
                                    theme.palette.background.primary,
                                  borderRadius: "4px",
                                  paddingX: "8px",
                                  paddingY: "5px",
                                }}
                              >
                                {/* <ListItem sx={{ paddingX: "10px" }}> */}
                                {item._source.campaign_description}
                                {/* </ListItem> */}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  ))
                ) : (
                  <NoDataFound />
                )}
              </LoadingIndicator>
            </Box>
          </Grid>
          {props.influencersCampaign.hits
            ? props.influencersCampaign.hits.length !== 0 &&
              !isRequesting && (
                <PaginationUI
                  pagelength={props.pagination.total_page_no}
                  page={props.pagination.current_page_no}
                  handleChange={handleChangePagination}
                />
              )
            : null}
        </Grid>
      </Box>
      <MuiSnackbarAlert
        open={noFilterAlert}
        message={"No Filters Detected !"}
        onClose={() => setNoFilterAlert(false)}
      />
    </React.Fragment>
  );
}

export default connect(mapStateToProps)(InfluencersCampaigns);

function chipTextDelimiter(text) {
  if (text.length <= 18) {
    return text;
  }
  return text.slice(0, 18 - 3) + "...";
}
